import React, { forwardRef, useEffect, useImperativeHandle, useState,useRef } from 'react';
import PropTypes from 'prop-types';
import './iconCheckbox.scss';
import star_off_icon from '../../atoms/customIcons/star_off_icon.svg';
import star_icon from '../../atoms/customIcons/star_icon.svg';
/**
 * Basic input checkbox with label.
 */
const IconCheckbox = forwardRef((props, ref) => {
  const {
    children, value, inline, checked, onChange, className, id,disabled,
  } = props;
  const myRef=useRef(null);
  const [checkedState, setCheckedState] = useState(checked);

  const handleChange = (checkedState) => {
    console.log("handleChange",checkedState);    
    let newValue=!checkedState;
    setCheckedState(newValue);
    const newEvent={...{target:{id:"is_favorite",value:newValue,checked:newValue}}};
    onChange(newEvent);
  
  };

  useEffect(() => {
    // console.log("useEffect checked",checked);
    // setCheckedState(checked=="on"?true:false);
    // myRef.current.checked=checked;
  }, [checked]);


  return (
    <div className={"iconCheckbox "}>
      <div className={`custom-checkbox form-check ${inline ? 'form-check-inline' : ''} ${className}`} id={id} onClick={()=>{handleChange(checkedState)}}>
        <input ref={myRef} className="form-check-input" id={id} type="checkbox" disabled={disabled} checked={checkedState} />
        <div class="icon-box">
          {!checked && <img src={star_off_icon} />}
          {checked && <img src={star_icon}/>}

        </div>
        <label className="form-check-label" htmlFor={id}>{children}</label>
      </div>
    </div>
  );
});

IconCheckbox.propTypes = {
  /**
   * Id of input checkbox
   */
  id: PropTypes.string,
  /**
   * Label text
   */
  children: PropTypes.string,
  /**
   * Value to send when the checkbox is clicked
   */
  value: PropTypes.string,
  /**
   * Print the checkbox inline or block
   */
  inline: PropTypes.bool,
  /**
   * The checkbox is checked
   */
  // checked: PropTypes.bool,
   /**
   * The disabled
   */
    disabled: PropTypes.bool,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Custom css class
   */
  className: PropTypes.string,
};

IconCheckbox.defaultProps = {
  id: '',
  inline: false,
  checked: false,
  disabled:false,
  value: '',
  children: '',
  onChange: () => {},
  className: '',
};

export default IconCheckbox;
